export default {
  'selectMonth': 'Select Month',
  'jan': 'January',
  'feb': 'Feburary',
  'mar': 'March',
  'apr': 'April',
  'may': 'May',
  'jun': 'June',
  'jul': 'July',
  'aug': 'August',
  'sep': 'September',
  'oct': 'October',
  'nov': 'November',
  'dec': 'December'
}



// WEBPACK FOOTER //
// ./src/i18n/es/calendar.js